import { render } from "./MyFeed.vue?vue&type=template&id=31cfa0d8&scoped=true"
import script from "./MyFeed.vue?vue&type=script&lang=js"
export * from "./MyFeed.vue?vue&type=script&lang=js"

import "./MyFeed.vue?vue&type=style&index=0&id=31cfa0d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cfa0d8"]])

export default __exports__